// eslint-disable-next-line import/prefer-default-export
export const CATEGORY_GET = 'CATEGORY_GET';